function ApiCacheService($cacheFactory, apiUrls) {
  const base = apiUrls.masterDbUrl;
  return {
    clearAllAddresses() {
      $cacheFactory.get('$http').remove(`${base}/addresses/`);
    },
    clearAllPayments() {
      $cacheFactory.get('$http').remove(`${base}/payments/`);
    },
    clearPayment(paymentId) {
      $cacheFactory.get('$http').remove(`${base}/payments/${paymentId}/`);
      this.clearAllPayments();
    }
  };
}
ApiCacheService.$inject = ['$cacheFactory', 'apiUrls'];

module.exports = ApiCacheService;
